module.exports = __webpack_public_path__ + "src/img/artist/name07.svg?d4d17bfa88d4c19b86953476bcb7ec8a";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name07.svg
// module id = 143
// module chunks = 0